<template>
  <div>
    <table-layout
      pkField="id"
      :selected.sync="selected"
      :isAdmin="isAdmin"
      :loading="serversLoading"
      :items="dashboards"
      :columns="columns"
      :addOptions="['addDashboard']"
      @click:addNew="addDashboard"
    >
      <template #actions>
        <b-dropdown-item @click="changeAccess(true)" aria-role="listitem">{{
          $t('ui_settings.makePublic')
        }}</b-dropdown-item>
        <b-dropdown-item @click="changeAccess(false)" aria-role="listitem">{{
          $t('ui_settings.makePrivate')
        }}</b-dropdown-item>
        <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{ $t('lists.deleteDetail') }}</b-dropdown-item>
      </template>
    </table-layout>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import TableLayout from '@/layout/TableLayout'

const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'Dashboards',
  components: {
    TableLayout
  },
  mounted() {
    this.refetch()
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  data() {
    return {
      dashboards: [],
      serversLoading: false,
      dashboardsTypes: [],
      columns: [
        {
          sortable: true,
          field: 'name',
          label: 'columns.name',
          route: {
            name: 'dashboard',
            params: [
              {
                name: 'dashboard_id',
                field: 'id'
              }
            ]
          }
        },
        {
          sortable: true,
          field: 'access',
          label: 'columns.access'
        },
        {
          sortable: true,
          field: 'created_by',
          label: 'columns.created_by'
        }
      ],
      selected: []
    }
  },
  methods: {
    addDashboard() {
      this.$router.push({
        name: 'add_dashboard'
      })
    },
    refetch() {
      if (!this.serversLoading) {
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/dashboards`
        this.serversLoading = true
        fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.dashboards = data
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    deleteDashboards(dashboard_ids, msg) {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/dashboards/delete`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          dashboard_ids: dashboard_ids
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$notify({
            message: this.$t('notification.removed', {
              msg: msg
            }),
            type: 'success'
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    openDialogRemove() {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }
      const indexSet = new Set(this.selected)
      const dashboards = this.dashboards
        .filter(value => {
          return indexSet.has(value.id)
        })
        .map(d => {
          return d['name']
        })
      const msg = dashboards
        .map(d => {
          return d
        })
        .join(', ')

      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: msg
        })}?`,
        onConfirm: () => {
          this.serversLoading = true
          this.deleteDashboards(this.selected, msg).finally(() => {
            this.serversLoading = false
            this.refetch()
          })
        }
      })
    },
    changeAccess(access) {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }

      this.serversLoading = true
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/dashboards/change_access`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          dashboard_ids: this.selected,
          access: access
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.serversLoading = false
          this.refetch()
        })
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  width: 100%;
}
</style>
